import { autoinject, transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { NotificationClientService, NotificationType } from "@rightship-tech/common-ui/services/basic/notification-client.service";
import { InspectionReportTabs } from '@rightship-tech/rs-inspections-ui/views/pages/inspection-report-tabs/inspection-report-tabs';
import { InsightIndicatorModel } from "@rightship-tech/rs-inspections-ui/models/rightship-inspection.models";

@transient()
@autoinject
export class ReviewInspectionReportDialog {
    onProceed: () => Promise<boolean>;
    public viewModel;
    public model;

    constructor(private dialogClientService: DialogClientService, private notificationClientService: NotificationClientService, 
        private inspectionReportTabs: InspectionReportTabs
    ) {

    }

    activate(model: { onProceed: () => Promise<boolean>, inspectionId: number, validUntil: string, validUntilText: string, 
        statusName: string, statusId: number, summary: string, formHasBeenSubmitted: boolean, insightIndicators: InsightIndicatorModel[], closeoutType: string })
    {
        this.viewModel = this.inspectionReportTabs;
        this.model = {
            viewInDialog: true,
            inspectionId: model.inspectionId,
            validUntil: model.validUntil,
            validUntilText: model.validUntilText,
            statusName: model.statusName,
            statusId: model.statusId,
            hideShareButton: true,
            summary: model.summary,
            preview: true,
            formHasBeenSubmitted: model.formHasBeenSubmitted,
            insightIndicators: model.insightIndicators,
            closeoutType: model.closeoutType
        }
        this.onProceed = model.onProceed;
    }

    close() {
        this.dialogClientService.hide();
    }

    async save() {
        try {
            const result = await this.onProceed();

            if (result) {
                //close all dialogs
                this.dialogClientService.hide(true, "default", true);
                this.notificationClientService.show("Success", "Submit successfully", NotificationType.Success);
            }
        }
        catch (e) {

            //Add error message
            this.notificationClientService.show("Error", "Submit Failed", NotificationType.Error);
        }
    }
}